export default {"src":"/_next/static/media/return.aaafb699.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};